import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        //首页
        {
            path: "/",
            component: () =>
                import ("@/pages/homePage/index.vue")
        },
        //招募合伙人
        {
            path: "/recruitPartners",
            component: () =>
                import ("@/pages/recruitPartners/index.vue")
        },
        {
            path: "/performance",
            component: () =>
                import ("@/pages/recruitPartners/performance/index.vue")
        },
        {
            path: "/construction",
            component: () =>
                import ("@/pages/recruitPartners/construction/index.vue")
        },
        {
            path: "/sketchUp",
            component: () =>
                import ("@/pages/recruitPartners/sketchUp/index.vue")
        },
        /* {
          path: "/reTouch",
          component: () => import("@/pages/recruitPartners/reTouch/index.vue")
        }, */
        //关于收费
        {
            path: "/cost",
            component: () =>
                import ("@/pages/cost/index.vue")
        },
        //关于改图
        {
            path: "/modify",
            component: () =>
                import ("@/pages/modify/index.vue")
        },
        //关于图小助
        {
            path: "/about",
            component: () =>
                import ("@/pages/about/index.vue")
        },
        {
            path: "/homePage/downloadApp",
            component: () =>
                import ("@/pages/homePage/downloadApp")
        }
    ]
});